//ACTIONS
import {message} from "antd";

import {
    MODAL_VISIBLE,
    SET_ADMATERIAL,
    SET_APPROVING,
    SET_BOOKING,
    SET_BOOKING_TYPE,
    SET_CONFIGURATION,
    SET_CURRENT_CREATIVE,
    SET_CURRENT_MATSPEC,
    SET_CURRENT_TAB,
    SET_FIELD_TRANSLATIONS,
    SET_FIELDS_TO_SAVE,
    SET_LANGUAGE,
    SET_MATSPECS_TO_SUBMIT,
    SET_PREFLIGHT_REPORT,
    SET_SUBMITTING,
    SET_TRANSLATIONS,
    TOGGLE_SPLASH,
} from "../constants";
import {urlPath} from "../../components/Settings";
import {getBookingUrl, saveAudit} from "../../components/Helpers";
import {getAuthHeader, setAuthHeader} from "../../utils/security";

const bookingType = (booking) => {
    const printedMatspecs =
        booking && booking.matspecs.filter((matspec) => matspec.printed);
    const digitalMatspecs =
        booking && booking.matspecs.filter((matspec) => !matspec.printed);
    const bookingHasDigital = digitalMatspecs && digitalMatspecs.length > 0;
    const bookingHasPrinted = printedMatspecs && printedMatspecs.length > 0;
    if (!bookingHasDigital) {
        return "PRINTED";
    } else if (bookingHasDigital && bookingHasPrinted) {
        return "DIGITAL_PRINTED";
    } else {
        return "DIGITAL";
    }
};

export const getAdMaterial = () => {
    return async (dispatch) => {
        const urlParams = new URLSearchParams(window.location.search);
        const dataParam = urlParams.get("data");
        const admaterialParam = urlParams.get("admaterial");
        const response = dataParam
            ? await fetch(
                  urlPath +
                      "/api/noauth/loadadmaterial?data=" +
                      dataParam +
                      "&timezone=" +
                      Intl.DateTimeFormat().resolvedOptions().timeZone
              )
            : await fetch(
                  urlPath +
                      "/api/loadadmaterial?admaterial=" +
                      admaterialParam +
                      "&timezone=" +
                      Intl.DateTimeFormat().resolvedOptions().timeZone,
                  {
                      credentials: "include",
                      headers: getAuthHeader(),
                  }
              );
        const data = await response.json();
        dispatch(setAdMaterial(data));
    };
};

export const setAdMaterial = (data) => {
    return {
        type: SET_ADMATERIAL,
        data,
    };
};

export const getBooking = (url, lang = "EN", audit) => {
    console.log("Loading booking from redux");
    return (dispatch) => {
        const bookingUrl = getBookingUrl();
        if (!bookingUrl) return null;
        fetch(getBookingUrl() + "&language=" + lang, { credentials: "include" })
            .then((response) => response.json())
            .then((data) => {
                if (data.AuthorizationToken) {
                    setAuthHeader({
                        Authorization: "Basic " + data.AuthorizationToken,
                    });
                    delete data.AuthorizationToken;
                }
                dispatch(setBookingType(bookingType(data)));
                if (audit && data.user.rol_enum !== "ADMIN")
                    saveAudit(
                        data.currentMaterialSpecification,
                        "MOBILE_CAMPAIGN_OPENED"
                    );
                return dispatch(setBooking(data));
            })
            .catch((e) => {
                console.error("Cannot load booking redux: " + e, e);
            });
    };
};

export const annotationSave = (admaterial, value, currentMatspec) => {
    return (dispatch) => {
        dispatch(setSubmitting(true));
        fetch(urlPath + "/api/annotationsave?admaterial=" + admaterial.id + "&x=10" + "&y=10" + "&w=10&h=10&color=" + "&text=" + encodeURIComponent(value) + "&reviewed=false" + "&status=" + 521,
            {method: "POST", credentials: "include", headers: getAuthHeader()})
            .then((response) => {
                console.log("Annotation saved", response.text());
                successMessage("Note submitted");
                dispatch(getBooking());
                dispatch(getCurrentMatspec(currentMatspec.id));
                dispatch(setModalVisible(false));
                dispatch(setSubmitting(false));
                dispatch(loadMaterial(admaterial.id));
            })
            .catch(() => {
                console.error("Cannot save annotation");
                errorMessage("Cannot submit note");
                dispatch(setModalVisible(false));
                dispatch(setSubmitting(false));
            });
    };
};

export const approveMaterial = (e, admaterial, currentMatspec) => {
    return (dispatch) => {
        if (admaterial.actions && admaterial.actions.APPROVE) {
            let targetUrl = urlPath + "/api" + admaterial.actions.APPROVE;
            dispatch(setApproving(true));
            fetch(targetUrl, {
                method: "POST",
                credentials: "include",
                headers: getAuthHeader(),
            })
                .then((response) => {
                    console.log("Approved admaterial", response.text());
                    dispatch(getBooking());
                    dispatch(getCurrentMatspec(currentMatspec.id));
                    dispatch(loadMaterial(admaterial.id));
                    dispatch(setModalVisible(false));
                    dispatch(setApproving(false));
                    successMessage("Creative approved");
                })
                .catch(() => {
                    console.error("Cannot approve");
                    errorMessage("Cannot approve");
                    dispatch(setApproving(false));
                });
        } else {
            dispatch(setApproving(false));
            dispatch(setModalVisible(false));
        }
    };
};

export const getCurrentMatspec = (id) => {
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/loadmatspec?matspec=" +
                id +
                "&timezone=" +
                Intl.DateTimeFormat().resolvedOptions().timeZone,
            {
                credentials: "include",
                headers: getAuthHeader(),
            }
        )
            .then((response) => response.json())
            .then((data) => {
                console.log("data", data);
                dispatch(setCurrentMatspec(data));
            })
            .catch((e) => {
                console.error("Cannot getCurrentMatspec: " + e, e);
            });
    };
};

export const loadMaterial = (id) => {
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/loadadmaterial?admaterial=" +
                id +
                "&timezone=" +
                Intl.DateTimeFormat().resolvedOptions().timeZone,
            {
                credentials: "include",
                headers: getAuthHeader(),
            }
        )
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                dispatch(setCurrentCreative(data));
            })
            .catch((e) => {
                console.error("Cannot load material!", e);
            });
    };
};

export const getPreflightReport = (admaterial) => {
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/loadpreflightreport?admaterial=" +
                admaterial.id +
                "&language=" +
                "en",
            { credentials: "include", headers: getAuthHeader() }
        )
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                dispatch(setPreflightReport(data));
            })
            .catch((e) => console.error("Cannot load report", e));
    };
};

export const getLanguage = (langCode, saveAudit, loadBooking = true) => {
    localStorage.setItem("IXMobileLangCode", langCode);
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/noauth/translations" +
                (langCode ? "?language=" + langCode : "")
        )
            .then((response) => response.json())
            .then((data) => {
                dispatch(setLanguage(data, langCode));
                if (loadBooking)
                    dispatch(getBooking(null, langCode, saveAudit));
                dispatch(getFieldTranslations(langCode));
            })
            .catch((e) => console.error("Cannot load translations", e));
    };
};

export const getTranslations = (langCode) => {
    localStorage.setItem("IXMobileLangCode", langCode);
    console.log("Fetching language");
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/noauth/translations" +
                (langCode ? "?language=" + langCode : "")
        )
            .then((response) => response.json())
            .then((data) => {
                dispatch(setTranslations(data, langCode));
            })
            .catch((e) => console.error("Cannot load translations", e));
    };
};

export const getConfiguration = () => {
    return (dispatch) => {
        fetch(urlPath + "/api/noauth/loadconfig")
            .then((response) => response.json())
            .then((data) => dispatch(setConfiguration(data)))
            .catch((e) => console.error("Cannot load config", e));
    };
};

export const getFieldTranslations = (langCode = "EN") => {
    return (dispatch) => {
        fetch(
            urlPath +
                "/api/noauth/fieldtranslations?type=Job" +
                (langCode ? "&language=" + langCode : "")
        )
            .then((response) => response.json())
            .then((data) => dispatch(setFieldTranslations(data.data)))
            .catch((e) => console.error("Cannot load field translations", e));
    };
};

export const setConfiguration = (data) => {
    return {
        type: SET_CONFIGURATION,
        data,
    };
};

export const setFieldTranslations = (data) => {
    return {
        type: SET_FIELD_TRANSLATIONS,
        data,
    };
};

export const setLanguage = (data, langCode) => {
    return {
        type: SET_LANGUAGE,
        data,
        langCode,
    };
};
export const setTranslations = (data, langCode) => {
    return {
        type: SET_TRANSLATIONS,
        data,
        langCode,
    };
};
export const setBooking = (data) => {
    return {
        type: SET_BOOKING,
        data,
    };
};
export const setModalVisible = (data) => {
    return {
        type: MODAL_VISIBLE,
        data,
    };
};

export const setPreflightReport = (data) => {
    return {
        type: SET_PREFLIGHT_REPORT,
        data,
    };
};

export const setCurrentMatspec = (data) => {
    return {
        type: SET_CURRENT_MATSPEC,
        data,
    };
};

export const setApproving = (data) => {
    return {
        type: SET_APPROVING,
        data,
    };
};
export const setSubmitting = (data) => {
    return {
        type: SET_SUBMITTING,
        data,
    };
};

export const setCurrentTab = (data) => {
    return {
        type: SET_CURRENT_TAB,
        data,
    };
};
export const setCurrentCreative = (data) => {
    return {
        type: SET_CURRENT_CREATIVE,
        data,
    };
};

export const setBookingType = (data) => {
    return {
        type: SET_BOOKING_TYPE,
        data,
    };
};

export const toggleSplash = (data) => {
    return {
        type: TOGGLE_SPLASH,
        data,
    };
};

export const setMatspecsToSubmit = data => {
  return {
    type: SET_MATSPECS_TO_SUBMIT,
    data
  }
}

export const setFieldsToSave = (data) => {
    /*const filtered = data.reduce((unique, item) => {
        return unique.field !== item.field ? { ...unique, item } : item;
    }); 
    const filtered = data.reduce((newListOfTags, current) => {
      if (!newListOfTags.some(x => x.field == current.field)) {
          newListOfTags.push(current);
      }
      return newListOfTags;
  }, []);
    console.log(filtered); */
    return {
        type: SET_FIELDS_TO_SAVE,
        data: data,
    };
};

// Helpers
export const successMessage = (text) => {
    message.success(text);
};
export const errorMessage = (text) => {
    message.error(text);
};



// WEBPACK FOOTER //
// ./src/redux/actions/index.js